<div class="flex flex-col h-full">
  <div class="flex-1 overflow-hidden">
    @if (isLoading()) {
      <elcia-loader/>
    } @else {
      <elcia-licence-plan-grid
        (licencePlanSelected)="onLicencePlanSelect($event)"
        [licencePlans]="licencePlans()"/>
    }
  </div>
</div>

@if (isFormDisplayed()) {
  <elcia-dialog
    (onAction)="onDialogSave()"
    (onClose)="closeForm()"
    [isActionLoading]="store.updateLicencePlanMutation.isPending()"
    [size]="'medium'"
    [title]="'entity.licence-plan' | translate">

    @if (isLoadingSelected()) {
      <elcia-loader/>
    } @else {
      <elcia-licence-plan-form
        (onSubmit)="submit($event)"
        [initialValue]="store.selectedLicencePlan() ?? undefined"
      />
    }
  </elcia-dialog>
}
